import {SHERLOCK_API_HOST} from "../constants";
import {getSymblAccessToken} from "./callScore";
import axios from "axios";
import audioFile from '../assets/audio/connected.wav';
import fetch from 'node-fetch'


export const findOutQuestions = async (conversation, answeredQuestions, callType) => {

    let parsedResponse

    try {

        const accessToken = await getSymblAccessToken();
        const data = {
            conversation: [...conversation].reverse(),
            answeredQuestions: answeredQuestions,
            callType: callType.name
        }

        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }
        console.log("Request data to Questions API :", data);

        const response = await axios.post(SHERLOCK_API_HOST + '/v1/question-response', data, {headers: headers});
        console.log("Received response from Questions API:", response);

        parsedResponse = JSON.parse(response.data.response);
        parsedResponse.processTime = response.headers.get('x-process-time');

    } catch (error) {
        console.error("Failed to generate questions.", error);
    }


    return parsedResponse
}


export const findOutObjections = async (conversation, answeredObjections, callType) => {

    let parsedResponse

    try {

        const accessToken = await getSymblAccessToken();
        const data = {
            conversation: [...conversation].reverse(),
            answeredObjections: answeredObjections,
            callType: callType.name
        }

        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }
        console.log("Request data to Objections API :", data);

        const response = await axios.post(SHERLOCK_API_HOST + '/v1/objection-response', data, {headers: headers});
        console.log("Received response from Objections API:", response);

        parsedResponse = JSON.parse(response.data.response);
        parsedResponse.processTime = response.headers.get('x-process-time');

    } catch (error) {
        console.error("Failed to generate Objection.", error);
    }


    return parsedResponse
}





export const findOutObjections_new = async (conversation, answeredObjections, callType, onStreamUpdate) => {
    //const eventSource = new EventSource(SHERLOCK_API_HOST + '/v1/objection-response');

    const accessToken = await getSymblAccessToken();
    const data = {
        conversation: [...conversation].reverse(),
        answeredObjections: answeredObjections,
        callType: callType.name
    };

    const headers = {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json'
    };

    console.log("Request data to Objections API:", data);

    const response = await fetch(SHERLOCK_API_HOST + '/v1/objection-response', {
        method: 'POST',
        headers: headers,
        body: JSON.stringify(data)
    });

    // Get the readable stream from the response body
    const stream = response.body;
    // Get the reader from the stream
    const reader = stream.getReader();
    // Define a function to read each chunk

    let isObjection = true;

    const readChunk = () => {
        // Read a chunk from the reader
        reader.read().then(({value, done }) => {
                // Check if the stream is done
                if (done) {
                    // Log a message
                    console.log('Stream finished');
                    // Return from the function
                    onStreamUpdate("END", isObjection, 0)
                    return;
                }
                // Convert the chunk value to a string
                let chunkString = new TextDecoder().decode(value);
                onStreamUpdate(chunkString, isObjection, 0);
                if(chunkString.includes("\n")) {
                    //Each new line represent response of objection
                    isObjection = false;
                }
                // Read the next chunk
                readChunk();

        })
            .catch(error => {
                // Log the error
                console.error(error);
            });

    }

    // Start reading the first chunk
    onStreamUpdate("START", isObjection, 0);
    readChunk();
}


export const fetchAgendasDiscussed = async (conversation, agendaAlreadyCovered, callType) => {

    let response;

    try {
        const accessToken = await getSymblAccessToken();

        let requestData = {
            conversation: [...conversation].reverse(),
            agendaAlreadyCovered: agendaAlreadyCovered,
            callType: callType.name,
        };

        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }

        console.log("Request data to Script Adherence API", requestData);
        response = await axios.post(SHERLOCK_API_HOST + '/v1/script-adherence', requestData, {headers: headers});
        console.log("Received response from Script Adherence API:", response.data);

        response = response.data.response;

    } catch (error) {
        console.error("Failed to fetch agendas.", error);
    }

    return response;

}

export const checkCompliance = async (conversation, selectedCompliance, capturedCompliancePolicies) => {

    let response;
    try {
        const accessToken = await getSymblAccessToken();

        const data = {
            conversation: [...conversation].reverse(),
            compliance: selectedCompliance,
            capturedCompliancePolicies: capturedCompliancePolicies
        }

        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }

        response = await axios.post(`${SHERLOCK_API_HOST}/v1/check-compliance`, data, {headers: headers});
        console.log("Received response from compliance API:", response);

        response = response.data.response;

    } catch (error) {
        console.error("Failed to check compliance.", error);
    }

    return response;

}

export const checkCommunicationStyle = async (conversation, callType, capturedWarnings) => {

    let response;

    try {
        const accessToken = await getSymblAccessToken();

        const data = {
            conversation: [...conversation].reverse(),
            callType: callType.name,
            capturedWarnings: capturedWarnings || []
        };

        const headers = {
            'Authorization': `Bearer ${accessToken}`,
            'Content-Type': 'application/json'
        }

        console.log("Request data to communication API", data);

        response = await axios.post(SHERLOCK_API_HOST + '/v1/communication-style', data, {headers: headers});
        console.log("Received response from Communication API:", response.data);

        response = response.data.response;

    } catch (error) {
        console.error("Failed to check communication.", error);
    }

    return response;
}

export const generateSampleScript = async (callType, website) => {
    const requestBody = {
        callType: callType,
        website: website
    };

    console.log("Request body Generate Script : ", requestBody);
    const accessToken = await getSymblAccessToken();

    let data;

    try {
        const response = await fetch(`${SHERLOCK_API_HOST}/v1/generate-script`, {
            method: 'POST',
            body: JSON.stringify(requestBody),
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            }
        });

        if (!response.ok) {
            const errorData = await response.json();
            console.log('Error generating script:', errorData);
            throw errorData;
        }

        data = await response.json();

        console.log("Received response from Generate Script API:", data);
    } catch (error) {
        console.error("Failed to generate script.", error);
    }
    return data;

}


export const talkToLLM = async (conversationRef, scriptTitle, callContext, selectedAssistantNames) => {
    let responseText;
    try {

        let data = {
            conversation: [...conversationRef.current],
            callType: scriptTitle,
            callContext: callContext,
            criteria: selectedAssistantNames
        }

        console.log("Request data to talkToLLM API :", data);

        const response = await axios.post(`${SHERLOCK_API_HOST}/v1/talkToLLM`, data);
        console.log("Received response from talkToLLM API:", response);

        responseText = response.data.response;

    } catch (error) {
        console.error("Failed to get reply from talkToLLM API.", error);
    }

    return responseText;

}

export const getConnectedAudioData = async () => {
    console.log("Getting audio data");
    const response = await fetch(audioFile);
    const arrayBuffer = await response.arrayBuffer();
    const uint8Array = new Uint16Array(arrayBuffer);
    return uint8Array;
}